module.exports = __webpack_public_path__ + "img/lugares2.761784ff.jpg";